import { render, staticRenderFns } from "./SignSentDocument.vue?vue&type=template&id=bf876b86&scoped=true&"
import script from "./SignSentDocument.vue?vue&type=script&lang=js&"
export * from "./SignSentDocument.vue?vue&type=script&lang=js&"
import style0 from "./SignSentDocument.vue?vue&type=style&index=0&id=bf876b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf876b86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/evolvo/klientai.cramo.lt/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFadeTransition } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VFadeTransition,VLayout})
